export default __webpack_public_path__ + "assets/169b274091d30dd8720d1ba1b4c8c44b.svg";